import Image from 'next/image';
import Slider from "react-slick";
import {useEffect, useState} from "react";
import {PhotoSlider} from "@/components/city/PhotoSlider";
import styled from "styled-components";

import IC_LEFT_GOLD from '/public/images/ic_left_gold.svg';
import IC_RIGHT_GOLD from '/public/images/ic_right_gold.svg';
import {useRouter} from "next/router";

const NavigationWrapper = styled.div`
    user-select: none;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    display: flex;
    justify-content: space-between;
    z-index: 999;
    pointer-events: none; /* Makes the entire wrapper non-clickable */

    > * { /* Direct children (items) */
        pointer-events: auto; /* Enables clicking on navigation items */
    }
`;

const NavigationButton = styled.div`
    text-shadow: 1px -1px 6px rgba(0, 0, 0, 0.38);
    color: white;
    font-size: 24px;
    cursor: pointer;
    padding: 20px;
    transform: ${(props) => (props.flip ? 'scaleX(-1)' : 'none')};
`;

const SlideCounter = styled.div`
    user-select: none;
    text-shadow: 1px -1px 6px rgba(0, 0, 0, 0.38);
    position: absolute;
    bottom: 20px;
    left: 50%;
    color: #fff;
    z-index: 9999;
    transform: translate(-50%, -50%);
`;
export function PhotoCarousel({ photos }) {
    let slider;
    const router = useRouter();
    const [isOpen, setIsOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleOpen = (index) => {
        setCurrentIndex(index);
        setIsOpen(true);
    };

    const [sliderKey, setSliderKey] = useState(0);

    useEffect(() => {
        const handleRouteChange = () => {
            setCurrentIndex(0);
            setSliderKey(prev => prev + 1); // force slider remount
        };

        router.events.on('routeChangeComplete', handleRouteChange);
        return () => {
            router.events.off('routeChangeComplete', handleRouteChange);
        };
    }, [router.events]);


    const settings = {
        initialSlide: currentIndex,
        slidesToShow: 1,
        slidesToScroll: 1,
        afterChange: (current) => setCurrentIndex(current),
        arrows: false,

        infinite: photos.length > 1, // Prevent infinite loop for 1 photo
        speed: 500,
        adaptiveHeight: true
    };

    const [isDragging, setIsDragging] = useState(false);

    const handleMouseDown = () => {
        setIsDragging(false); // Reset dragging state on mouse down
    };

    const handleMouseMove = () => {
        setIsDragging(true); // If mouse moves, set dragging to true
    };

    const handleMouseUp = (index) => {
        if (!isDragging) {
            handleOpen(index); // Only fire if not dragging
        }
    };



    return (
        <div style={{position:'relative'}}>
            <NavigationWrapper>
                <NavigationButton onClick={() => slider.slickPrev()}>
                    <Image src={IC_LEFT_GOLD} alt={'<'} style={{width:'40px', height:'40px', objectFit:'contain'}} />
                </NavigationButton>
                <NavigationButton onClick={() => slider.slickNext()}>
                    <Image src={IC_RIGHT_GOLD} alt={'>'} style={{width:'40px', height:'40px', objectFit:'contain'}} />
                </NavigationButton>
            </NavigationWrapper>
            <Slider key={sliderKey} ref={(c) => (slider = c)} {...settings}>
                {photos.map((photo, index) => (
                    <div
                        key={index}
                        onMouseDown={handleMouseDown}
                        onMouseMove={handleMouseMove}
                        onMouseUp={() => handleMouseUp(index)}
                    >
                        <Image
                            src={photo.url}
                            alt={photo.alt ?? photo.name}
                            width={550}
                            height={370}
                            style={{
                                maxWidth: "100%",
                                width: "550px",
                                height: "370px",
                                objectFit: "cover",
                                display: "block",
                                margin: "auto" // Ensure it centers properly
                            }}
                        />
                    </div>
                ))}
            </Slider>

            {!isOpen && <SlideCounter>
                {currentIndex + 1} / {photos.length}
            </SlideCounter>}

            <PhotoSlider
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                currentIndex={currentIndex}
                setCurrentIndex={setCurrentIndex}
                photos={photos}
            />
        </div>
    );
}
